<iot-platform-ui-form-group data-cy="iot-platform-ui-filter-date-field" [fields]="fields()" [group]="form" />

@if (showDateRange()) {
  <iot-platform-ui-date-range
    class="iot-platform-ui-filter-date-field__date-range"
    data-cy="iot-platform-ui-filter-date-field"
    (dateRangeChange)="onDateRangeChange($event)"
    [clearDateRangeFilters$]="clearDateRangeFilters$"
    [dateFormatterPattern]="$safeNavigationMigration(fieldOptions()?.dateFormatterPattern)"
    [disabled]="disabled()"
    placeholderClear="FILTER_ENGINE.CLEAR"
    placeholderFrom="FILTER_ENGINE.DATE_PLACEHOLDER_FROM"
    placeholderHours="FILTER_ENGINE.DATE_PLACEHOLDER_HOURS"
    placeholderMinutes="FILTER_ENGINE.DATE_PLACEHOLDER_MINUTES"
    placeholderTo="FILTER_ENGINE.DATE_PLACEHOLDER_TO"
  />
}
